<template>
    <tbody class="line-container">
        <tr :id="order.id">
            <td class="item-qty-index">
                <p class="clr_gray sz_z">{{parseInt(increment) + parseInt(1)}}</p>
            </td>
            <td>
                <div class="num_z">
                    <span v-if="order.category" class="clr_gray">{{order.category.title}}</span>
                    <p class="clr_black">{{order.steel_type}}</p>
                </div>
            </td>
            <td>
                <div class="Voorges_z">
                    <p>
                        <span>Vorm</span>{{order.article ? order.shape.name : order.shape_code}}
                    </p>
                    <p v-if="shapeIsRound">
                        <span>Maat</span>{{round(widthOrThickness, 2)}} mm
                    </p>
                    <p v-else>
                        <span>Maat</span>{{round(order.width, 2)}} mm x {{round(order.thickness, 2)}} mm
                    </p>
                </div>
            </td>
            <td>
                <div class="Voorges_z">
                    <p>
                        <span>Lengte</span> {{round(order.length, 2)}} mm
                    </p>

                    <p>
                        <span>Aantal</span> <button class="unit-customize-buttons min-button" :class="{'ghost': order.pieces == 1}" @click="removeUnit" v-bind:disabled="removingUnit || order.pieces == 1"></button> {{order.pieces}} <button class="unit-customize-buttons plus-button" @click="addUnit" v-bind:disabled="addingUnit"></button>
                    </p>
                </div>
            </td>
            <td class="prize" v-if="showPrice">
                <p>{{order.article == null ? "€"+round(parseFloat(order.price_per_piece) * parseInt(order.pieces), 2).toFixed(2) : ""}}</p>
            </td>
            <td class="prize" v-else>
                <p></p>
            </td>


            <table class="buttons_table">
                <tr>
                    <td class="buttons_z">
                        <label class="order">
                            <input type="radio" v-bind:disabled="!customer&&!order.residual_product_id" @click="changeOrderType(order, $event, 1)" :name="'radio'+order.id" :checked="order.order_offer ? 'checked' : ''">
                            <span>BESTEL</span>
                        </label>
                        <label class="offer">
                            <input type="radio" v-bind:disabled="posting||order.residual_product_id" @click="changeOrderType(order, $event, 0)" :name="'radio'+order.id" :checked="! order.order_offer ? 'checked' : ''">
                            <span>OFFERTE</span>
                        </label>
                    </td>
                    <td class="cancel">
                        <a href="" @click="deleteOrderLine(order.id)" onclick="return false;"><img src="img/cancel_icon.svg" loading="lazy" alt=""></a>
                    </td>
                </tr>
            </table>
            <table class="customize-buttons" v-if="canSwitchOrderOffer">
                <tr>
                    <td class="customize-button">
                        <p class="clr_gray edit">
                            <!--<a :href="/specificeren/ + order.category.slug + '/' + order.steel_slug + '?orderlineId=' + order.id">wijzigen</a>-->
                            <a :href="/specificeren/ + order.category.slug + '/' + order.steel_slug + '?orderlineId=' + order.id">wijzigen</a>
                        </p>
                    </td>
                    <td class="customize-button">
                        <p class="clr_gray duplicate">
                            <!--<a :href="/specificeren/ + order.category.slug + '/' + order.steel_slug">dupliceren & aanpassen</a>-->
                            <a :href="/specificeren/ + order.category.slug + '/' + order.steel_slug">dupliceren & aanpassen</a>
                        </p>
                    </td>
                </tr>
            </table>

        </tr>
    </tbody>
</template>

<script>

    let auth = document.head.querySelector('meta[name="auth"]').content;

    import customerShoppingCart from './helpers/product/customer';
    import guestShoppingCart from './helpers/product/guest';

    let mixin = guestShoppingCart;

    if (parseInt(auth)) {
        mixin = customerShoppingCart;
    }

    export default {
        mixins: [mixin],
        props: [
            'order',
            'increment',
            'customer'
        ],
        data: function() {
            return {
                posting: false,
                addingUnit: false,
                removingUnit: false,
            }
        },
        computed: {
            shapeIsRound: function() {
                return this.order.shape_code === 'Rond';
            },
            widthOrThickness: function() {
                if (this.order.width == '0.00') {
                    return this.order.thickness;
                }
                return this.order.width;
            },
            showPrice: function() {
                if(this.order.order_offer == 1) {
                    return true;
                }

                if((this.order.is_residual_product || this.order.residual_product_id) && this.order.price_per_piece) {
                    return true;
                }

                return false;
            }
        },
        mounted: function() {
            WinkelwagenEventBus.$on('disable-radios', () => {
                this.posting = true;
            });
            WinkelwagenEventBus.$on('enable-radios', () => {
                this.posting = false;
            });
        },
        methods: {
            round: function(value, precision) {
                var multiplier = Math.pow(10, precision || 0);
                return Math.round(value * multiplier) / multiplier;
            },
            removeOrderLine: function(id) {
                $("#"+id).hide();
            },
        }
    }
</script>
<style lang="scss" scoped>

    .buttons_table{
        width: 300px;
        float: right;
        margin-top: 20px;
        margin-bottom: 0;
    }
    .buttons_table .cancel {
        width:30px;
    }
    .line-container tr{
        vertical-align: middle;
        position: relative;
    }

    .customize-buttons {
        width: 300px;
        float: right;
    }
    .customize-buttons tr td {
        border-right: none !important;
    }
    .customize-button {
        width: 65px;
    }
    .unit-customize-buttons{
        width: 15px;
        height: 15px;
        border: none;
        cursor: pointer;
    }

    .min-button{
        margin-right: 5px;
        background: url(/img/minus.svg) center center no-repeat;
    }
    .plus-button{
        margin-left: 5px;
        background: url(/img/plus.svg) center center no-repeat;
    }

    .duplicate{
        margin-top: 10px;
        position: relative;

        a {
            padding-top: 5px;
            text-decoration: none;
            color: #808080;
            margin-left: 25px;

            &:before {
                content: "";
                width: 20px;
                height: 20px;
                position: absolute;
                /*top: 18px;*/
                left: 0;
                background: url(/img/duplicate.svg) center center no-repeat;
            }
        }

    }

    .edit{
        margin-top: 10px;
        position: relative;

        a {
            padding-top: 5px;
            text-decoration: none;
            margin-left: 25px;
            color: #808080;

            &:before {
                content: "";
                width: 20px;
                height: 20px;
                position: absolute;
                /*top: 18px;*/
                left: 0;
                background: url(/img/wijzigen.svg) center center no-repeat;
            }
        }
    }

    .ghost{
        cursor: not-allowed;
        opacity: .5;
    }

    @media (max-width: 1113px) and (min-width:1023px) {
        .buttons_table, .customize-buttons {
            width:200px;
        }
        .buttons_table .cancel {
            width:50px;
        }
        .customize-button {
            display: block;
            width: 100% !important; /* the original table settings override */
            word-break: keep-all;
        }
    }
    @media (max-width: 1023px) {
        .buttons_table, .customize-buttons {
            width: 100%;

            tr {
                padding: 23px 0 7px;
            }
        }
        .buttons_z {
            width: auto;
        }
        .customize-button {
            width: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/product.vue